import { render } from "./TimeseriesChart.vue?vue&type=template&id=670ddad6"
import script from "./TimeseriesChart.vue?vue&type=script&lang=js"
export * from "./TimeseriesChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__